import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { AngularFireAuthModule } from '@angular/fire/auth';

const routes: Routes = [{
  path: '',
  redirectTo: 'customers',
  pathMatch: 'full'
},
{
  path: 'login',
  loadChildren: '../modules/login/login.module#LoginModule'
},
{
  path: 'customers',
  loadChildren: '../modules/customers/customers.module#CustomersModule',
  canActivate: [AuthGuardService]
},
{
  path: 'projects',
  loadChildren: '../modules/projects/projects.module#ProjectsModule',
  canActivate: [AuthGuardService]
}, {
  path: 'endpoints',
  loadChildren: '../modules/endpoints/endpoints.module#EndpointsModule',
  canActivate: [AuthGuardService]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes), AngularFireAuthModule],
  exports: [RouterModule],
  providers: [AuthGuardService]
})
export class AppRoutingModule { }
